(() => {
  const stateKey = '__linkdLatestWorkshop';
  if (window[stateKey]) return;

  const state = { request: null, latest: null };
  window[stateKey] = state;

  function targets(scope, selector) {
    const matches = [...scope.querySelectorAll(selector)];
    if (scope instanceof Element && scope.matches(selector)) matches.unshift(scope);
    return matches;
  }

  function applyLatest(scope = document) {
    const latest = state.latest;
    if (!latest) return;

    targets(scope, '[data-linkd-workshop-hero]').forEach((target) => {
      const incoming = latest.hero.cloneNode(true);
      const currentLabel = target.querySelector('[data-workshop-cta]')?.textContent?.trim();
      const incomingCta = incoming.querySelector('[data-workshop-cta]');
      if (currentLabel && incomingCta) incomingCta.textContent = currentLabel;
      target.replaceChildren(...incoming.childNodes);
    });

    targets(scope, '[data-linkd-workshop-feature]').forEach((target) => {
      const incoming = latest.feature.cloneNode(true);
      const headingId = target.querySelector('h2')?.id || target.getAttribute('aria-labelledby')?.trim().split(/\s+/)[0];
      const incomingHeading = incoming.querySelector('h2');
      if (headingId && incomingHeading) incomingHeading.id = headingId;
      target.replaceChildren(...incoming.childNodes);
      target.hidden = false;
    });

    targets(scope, '[data-linkd-workshop-link]').forEach((link) => {
      link.setAttribute('href', latest.url);
    });
  }

  function readLatest(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector('template[data-linkd-latest-workshop]');
    if (!(source instanceof HTMLTemplateElement) || source.dataset.productType?.trim().toLowerCase() !== 'workshop ticket') return null;
    if (!/^\d+$/.test(source.dataset.productId || '') || !source.dataset.productUrl) return null;

    const url = new URL(source.dataset.productUrl, window.location.origin);
    const productPath = /^(?:\/[a-z]{2}(?:-[a-z0-9]{2,8})*)?\/products\/[^/]+\/?$/i;
    if (url.origin !== window.location.origin || url.username || url.password || !productPath.test(url.pathname)) return null;

    const hero = source.content.querySelector('template[data-workshop-fragment="hero"]');
    const feature = source.content.querySelector('template[data-workshop-fragment="feature"]');
    if (!(hero instanceof HTMLTemplateElement) || !(feature instanceof HTMLTemplateElement)) return null;
    if (!hero.content.childElementCount || !feature.content.childElementCount) return null;
    if (!feature.content.querySelector('h2')) return null;

    return { url: `${url.pathname}${url.search}${url.hash}`, hero: hero.content, feature: feature.content };
  }

  function loadLatest() {
    if (state.request) return state.request;
    const configElement = document.getElementById('LinkdLatestWorkshopConfig');
    if (!configElement) return Promise.resolve(null);

    state.request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const config = JSON.parse(configElement.textContent || '{}');
        if (typeof config.url !== 'string' || !config.url) return null;
        const url = new URL(config.url, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password) return null;
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok || controller.signal.aborted) return null;
        const html = await response.text();
        if (controller.signal.aborted) return null;
        state.latest = readLatest(html);
        return state.latest;
      } catch {
        return null;
      } finally {
        clearTimeout(timeout);
      }
    })();

    return state.request;
  }

  function hydrate(scope = document) {
    if (state.latest) {
      applyLatest(scope);
      return;
    }
    loadLatest().then((latest) => {
      if (latest) applyLatest(scope);
    });
  }

  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate(), { once: true });
  } else {
    hydrate();
  }
})();
